import { render, staticRenderFns } from "./KeywordRow.vue?vue&type=template&id=4bfb08e1&"
import script from "./KeywordRow.vue?vue&type=script&lang=ts&"
export * from "./KeywordRow.vue?vue&type=script&lang=ts&"
var disposed = false

function injectStyles (context) {
  if (disposed) return
  var style0 = require("./KeywordRow.vue?vue&type=style&index=0&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/actions-runner/_work/mfe-ca-tester/mfe-ca-tester/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bfb08e1')) {
      api.createRecord('4bfb08e1', component.options)
    } else {
      api.reload('4bfb08e1', component.options)
    }
    module.hot.accept("./KeywordRow.vue?vue&type=template&id=4bfb08e1&", function () {
      api.rerender('4bfb08e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/KeywordRow.vue"
export default component.exports